"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectedQuestionBankWithSubscriptions = exports.useQuestionBanksWithSubscriptions = exports.useProductIdsForUserSubscriptions = exports.usePracticeExamTemplateAccessIdsForUser = void 0;
var _reactRedux = require("react-redux");
var _subscriptions = require("../selectors/subscriptions.js");
var _questionBanks = require("../selectors/questionBanks.js");
/* useQuestionBanksWithSubscriptions()
 *
 * Returns a List of every available QuestionBank including the current User's Subscriptions and overall subscription statuses.
 * Results are unsorted.
 */
var useQuestionBanksWithSubscriptions = function useQuestionBanksWithSubscriptions() {
  return (0, _reactRedux.useSelector)(function (state) {
    return (0, _questionBanks.selectQuestionBanksWithSubscriptions)(state);
  });
};

/* useSelectedQuestionBankWithSubscriptions()
 *
 * Returns the current User's selected QuestionBank including Subscriptions and overall subscription statuses.
 * Returns undefined if not found.
 */
exports.useQuestionBanksWithSubscriptions = useQuestionBanksWithSubscriptions;
var useSelectedQuestionBankWithSubscriptions = function useSelectedQuestionBankWithSubscriptions() {
  return (0, _reactRedux.useSelector)(function (state) {
    return (0, _questionBanks.selectCurrentQuestionBankWithSubscriptions)(state);
  });
};

/* useProductIdsForUserSubscriptions()
 *
 * Returns the current User's product IDs that are associated with their subscriptions
 */
exports.useSelectedQuestionBankWithSubscriptions = useSelectedQuestionBankWithSubscriptions;
var useProductIdsForUserSubscriptions = function useProductIdsForUserSubscriptions() {
  var subscriptions = (0, _reactRedux.useSelector)(_subscriptions.selectSubscriptionsForCurrentUser);
  return subscriptions.toList().filter(function (sub) {
    return sub.get('product_id');
  }).map(function (sub) {
    return sub.get('product_id');
  });
};
exports.useProductIdsForUserSubscriptions = useProductIdsForUserSubscriptions;
var usePracticeExamTemplateAccessIdsForUser = function usePracticeExamTemplateAccessIdsForUser() {
  var session = (0, _reactRedux.useSelector)(function (state) {
    return state.session;
  });
  var accessTrackers = (0, _reactRedux.useSelector)(function (state) {
    return state.addonAccessTrackers;
  });
  return accessTrackers.toList().filter(function (tracker) {
    return tracker.get('question_bank_id') === session.get('selected_question_bank_id') && tracker.get('access_item_type') === 'practice_exam_template';
  }).map(function (tracker) {
    return tracker.get('access_item_id');
  });
};
exports.usePracticeExamTemplateAccessIdsForUser = usePracticeExamTemplateAccessIdsForUser;